export const newHeader = {
  "Como você está se sentindo?": "¿Cómo te sientes?",
  "Enviar": "Enviar",
  "Se sentindo muito feliz 😆": "Me siento muy feliz 😆",
  "Se sentindo feliz 🙂": "Me siento feliz 🙂",
  "Se sentindo neutro 😐": "Me siento neutral 😐",
  "Se sentindo triste 🙁": "Me siento triste 🙁",
  "Se sentindo muito triste 😓": "Me siento muy triste 😓",
  "Sentimento enviado.": "Sentimiento enviado.",
  "Nos conte porque você está se sentindo assim...": "Cuéntanos por qué te sientes así...",
  "Minha Equipe": "Mi Equipo",
  "Sem registro": "Sin registro",
  "Deseja voltar da pausa:": "¿Desea volver de la pausa?",
  "Tempo total em pausa:": "Tiempo total en pausa:",
  "Selecione o motivo da pausa": "Seleccione el motivo de la pausa",
  "Marcar Ponto": "Fichar",
  "Marcar Pausa": "Iniciar Pausa",
  "Em Pausa": "En Pausa",
  "Voltar da pausa": "Volver de la pausa",
  "Cancelar": "Cancelar",
  "Confirmar pausa": "Confirmar pausa",
  "Marcar pausa": "Iniciar pausa",
  "Início": "Inicio",
  "Lembretes": "Recordatorios",
  "Gestão de tarefas": "Gestión de tareas",
  "Comunicados": "Comunicados",
  "Documentos": "Documentos",
  "Feedbacks": "Comentarios",
  "Reuniões 1:1": "Reuniones 1:1",
  "Reembolsos": "Reembolsos",
  "Saldo de horas": "Saldo de horas",
  "Solicitações de ajuste": "Solicitudes de ajuste",
  "Férias/Afastamento": "Vacaciones/Ausencia",
  "Histórico de Ponto": "Historial de Fichajes",
  "Espelhos de Ponto": "Informes de Fichajes",
  "Log de Registros": "Registro de Fichajes",
  "Modo ponto": "Modo de fichaje",
  "Minha equipe": "Mi equipo",
  "Gestão de Ponto": "Gestión de Fichajes",
  "Gerenciar afastamentos": "Gestionar ausencias",
  "Solicitações da equipe": "Solicitudes del equipo",
  "Sobreaviso": "De guardia",
  "Modo escuro": "Modo oscuro",
  "Modo claro": "Modo claro",
  "Meu perfil": "Mi perfil",
  "Ouvidoria": "Defensoría del empleado",
  "Sair": "Cerrar sesión"
};


// WEBPACK FOOTER //
// ./src/resources/es/newHeader.js